import { useEffect, useRef, useState } from 'react';

const NoiseOverlay = () => <div className="grain-overlay" aria-hidden="true" />;

const CustomCursor = () => {
    const dotRef = useRef(null);
    const ringRef = useRef(null);
    const [hovering, setHovering] = useState(false);

    useEffect(() => {
        const dot = dotRef.current;
        const ring = ringRef.current;
        if (!dot || !ring) return;

        let mx = window.innerWidth / 2;
        let my = window.innerHeight / 2;
        let rx = mx;
        let ry = my;
        let raf = 0;

        const onMove = (e) => {
            mx = e.clientX;
            my = e.clientY;
            dot.style.transform = `translate3d(${mx}px, ${my}px, 0) translate(-50%, -50%)`;
        };
        const tick = () => {
            rx += (mx - rx) * 0.18;
            ry += (my - ry) * 0.18;
            ring.style.transform = `translate3d(${rx}px, ${ry}px, 0) translate(-50%, -50%)`;
            raf = requestAnimationFrame(tick);
        };
        raf = requestAnimationFrame(tick);

        const isInteractive = (el) => {
            if (!el || !(el instanceof Element)) return false;
            return !!el.closest(
                'a, button, [data-cursor="hover"], input, textarea, [role="button"]',
            );
        };
        const onOver = (e) => setHovering(isInteractive(e.target));
        const onOut = (e) => {
            if (!isInteractive(e.relatedTarget)) setHovering(false);
        };

        window.addEventListener('mousemove', onMove);
        window.addEventListener('mouseover', onOver);
        window.addEventListener('mouseout', onOut);
        return () => {
            cancelAnimationFrame(raf);
            window.removeEventListener('mousemove', onMove);
            window.removeEventListener('mouseover', onOver);
            window.removeEventListener('mouseout', onOut);
        };
    }, []);

    return (
        <>
            <div ref={dotRef} className="cursor-dot" aria-hidden="true" />
            <div
                ref={ringRef}
                className={`cursor-ring ${hovering ? 'is-hovering' : ''}`}
                aria-hidden="true"
            />
        </>
    );
};

export { NoiseOverlay, CustomCursor };
